/**
 * Transforme un texte pour permettre une
 * recherche insensible aux accents,
 * majuscules et balises HTML.
 */
export function normalizeTutorialText(
  value
) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Vérifie que tous les mots recherchés
 * sont présents dans le contenu.
 */
export function matchesTutorialSearch(
  values,
  normalizedQuery
) {
  if (!normalizedQuery) {
    return true;
  }

  const searchValues = Array.isArray(values)
    ? values
    : [values];

  const haystack =
    normalizeTutorialText(
      searchValues
        .filter(Boolean)
        .join(" ")
    );

  const terms =
    normalizeTutorialText(
      normalizedQuery
    )
      .split(" ")
      .filter(Boolean);

  return terms.every((term) =>
    haystack.includes(term)
  );
}